var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.formid!=0)?_c('div',[_c('button',{staticClass:"btn btn-default",on:{"click":function($event){$event.preventDefault();return _vm.openwindow()}}},[_c('i',{staticClass:"glyphicon glyphicon-cog"}),_vm._v(" "+_vm._s(_vm.translation(649))+"\r\n    ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }